import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Style from './StarRate.module.css'
const StarRate = ({rate}) => {
  return (
    <div className={Style.StoreRate}>
      <div className={Style.FixRate}>
        <div className={Style.RateHolder}>
          <div className={Style.grayStar}>
            <FontAwesomeIcon icon={faStar} /> 
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
          </div>
          <div className={Style.GoldStar} style={{ width: `${rate*20}%` }}>
            <div className={Style.GoldStarHolder}>
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StarRate
